// const APP_BASE_URL = "https://staging-staff.anciemdemia.com";
// const API_STUDENT_URL = "https://api.staging.anciemdemia.com/v1/student";
// const API_BASE_URL = "https://api.staging.anciemdemia.com/v1";

const APP_BASE_URL = process.env.REACT_APP_APP_BASE_URL;
const API_STUDENT_URL = process.env.REACT_APP_API_STUDENT_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export { API_BASE_URL, API_STUDENT_URL, APP_BASE_URL };
